import { Auth } from "@aws-amplify/auth";
const backendUrl = process.env.REACT_APP_TECHRADAR_BACKEND_URL

if (!backendUrl) {
  console.log(`REACT_APP_TECHRADAR_BACKEND_URL="${backendUrl}"`)
}

const awsExport = {
    Auth: {
      region: "eu-north-1",
      userPoolId: "eu-north-1_PL8jBcN0g",
      userPoolWebClientId: "4shndbudm69vq0de2gllbv7f1o",
      oauth: {
        domain: "digiatechradar.auth.eu-north-1.amazoncognito.com",
        scope: ["email", "openid"],
        redirectSignIn: `${window.location.origin}/auth/callback`,
        redirectSignOut: `${window.location.origin}/auth/signout`,
        responseType: "code",
      }
    },

    API: {
      endpoints: [
        {
          name: "TechRadar",
          endpoint: backendUrl,
          // based on https://docs.amplify.aws/lib/restapi/authz/q/platform/js
          custom_header: async () => {
            try {
              return {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              };
            } catch (e) {
              // if not logged in
              return {};
            }
          },
        },
      ],
    },
  }
  export default awsExport
